import { api } from '../services/api';

export type CurrencyTotals = Record<string, string>;
export interface DashboardSummary {
  as_of: string;
  timezone: string;
  company: { uf: string; companyname: string | null };
  counts: {
    invoices_this_month: number;
    quotes_this_month: number;
    users: number;
    clients: number;
    items: number;
  };
  year_to_date: CurrencyTotals;
  months: Array<{ month: string; current: CurrencyTotals; previous: CurrencyTotals }>;
  last_30_days: { from: string; to: string; count: number; totals: CurrencyTotals };
  unpaid: { count: number; overdue_count: number; partly_paid_count: number; totals: CurrencyTotals };
}

export const dashboardApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardSummary: builder.query<DashboardSummary, void>({
      query: () => ({ url: '/app/dashboard-summary/', method: 'GET' }),
      providesTags: [
        { type: 'Inv', id: 'LIST' },
        { type: 'Quote', id: 'LIST' },
        { type: 'User', id: 'LIST' },
        { type: 'Company', id: 'CURRENT' },
      ],
    }),
  }),
});

export const { useGetDashboardSummaryQuery } = dashboardApi;
